import { Node, mergeAttributes } from "@tiptap/core";

export const InsideLinkServerside = Node.create({
  name: "insideLinks",

  group: "block",
  content: "inline*",
  draggable: true,

  // content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'div[data-type="insideLinks"]',
      },
    ];
  },

  addAttributes() {
    return {
      thumbnail: { default: null },
      title: { default: null },
      id: { default: null },
      type: { default: null },
      url: { default: null },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => {
        return this.editor
          .chain()
          .insertContentAt(this.editor.state.selection.head, {
            type: this.type.name,
          })
          .focus()
          .run();
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-type": "insideLinks" }),
      0,
    ];
  },
});
